import { callAPI } from './callAPI';
import { getFilterPostParams } from './storageManager'
import { AppNameFromID } from './apps';

export const getClients = async (page = 1, limit = 10, sort = 'ASC', order = 'id') => {
    try {
        const response = await callAPI.get("/admin/clients", {
            params: { page, limit, sort, order }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const getClient = async (clientId) => {
    if (!clientId) return [];
    try {
        const response = await callAPI.get(`/admin/clients/${clientId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching roles for client ${clientId}:`, error);
        throw error;
    }
};

export const getClientRoles = async (clientId) => {
    if (!clientId) return [];
    try {
        const clientData = await getClient(clientId);
        const client = clientData.data || clientData;
        if (client && client.client_apps) {
            try {
                // Supposant que client_apps est une chaîne JSON
                if (typeof client.client_apps === 'string') {
                    return JSON.parse(client.client_apps);
                } else if (Array.isArray(client.client_apps)) {
                    return client.client_apps;
                }
                return [];
            } catch (e) {
                console.error("Failed to parse client_apps JSON:", e);
                return []; // Retourne un tableau vide si le parsing échoue
            }
        }
        return [];
    } catch (error) {
        console.error(`Error fetching roles for client ${clientId}:`, error);
        throw error;
    }
};

export const getUsers = async (page = 1, limit = 10, sort = 'ASC', order = 'id') => {
    try {
        const response = await callAPI.get("/admin/users", {
            params: { page, limit, sort, order }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const getUser = async (id) => {
    try {
        const response = await callAPI.get(`/admin/users/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const createUser = async (data) => {
    try {
        const response = await callAPI.post("/admin/users", data);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export const updateUser = async (id, data) => {
    try {
        const response = await callAPI.put(`/admin/users/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating user:', error);
        throw error;
    }
};

export const deleteUser = async (id) => {
    try {
        const response = await callAPI.delete(`/admin/users/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
    }
};

export const getEntities = async (page = 1, limit = 10, sort = '', order = '') => {
    try {
        const response = await callAPI.get("/entities", {
            params: { page, limit, sort, order }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching entities:', error);
        throw error;
    }
};

export const createEntity = async (data) => {
    try {
        const response = await callAPI.post("/entities", data);
        return response.data;
    } catch (error) {
        console.error('Error creating entity:', error);
        throw error;
    }
};

export const updateEntity = async (id, data) => {
    try {
        const response = await callAPI.put(`/entities/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating entity:', error);
        throw error;
    }
};

export const deleteEntity = async (id) => {
    try {
        const response = await callAPI.delete(`/entities/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting entity:', error);
        throw error;
    }
};

export const getQueries = async (page = 1, limit = 10, sort = 'ASC', order = 'id') => {
    try {
        const response = await callAPI.get("/admin/query", {
            params: { page, limit, sort, order }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching queries:', error);
        throw error;
    }
};

export const getQuery = async (id) => {
    try {
        const response = await callAPI.get(`/admin/query/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching query:', error);
        throw error;
    }
};
export const createQuery = async (data) => {
    try {
        const response = await callAPI.post("/admin/query", data);
        return response.data;
    } catch (error) {
        console.error('Error creating query:', error);
        throw error;
    }
};
export const updateQuery = async (id, data) => {
    try {
        const response = await callAPI.put(`/admin/query/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating query:', error);
        throw error;
    }
};
export const deleteQuery = async (id) => {
    try {
        const response = await callAPI.delete(`/admin/query/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting query:', error);
        throw error;
    }
};

export const getClause = async (app, category) => {
    try {
        const response = await callAPI.get(`/admin/clause/${app}/${category}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching clause:', error);
        throw error;
    }
};

export const createClause = async (data) => {
    try {
        const response = await callAPI.post("/admin/clause", data);
        return response.data;
    } catch (error) {
        console.error('Error creating clause:', error);
        throw error;
    }
};

export const updateClause = async (id, data) => {
    console.log('Updating clause with ID:', id, 'and data:', data);
    try {
        const response = await callAPI.put(`/admin/clause/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating clause:', error);
        throw error;
    }
};

export const deleteClause = async (id) => {
    try {
        const response = await callAPI.delete(`/admin/clause/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting clause:', error);
        throw error;
    }
};

export const createColdef = async (data) => {
    try {
        const response = await callAPI.post("/admin/coldef", data);
        return response.data;
    } catch (error) {
        console.error('Error creating coldef:', error);
        throw error;
    }
};

export const getColdef = async (queryId) => {
    try {
        const response = await callAPI.get(`/admin/coldef/${queryId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching coldef:', error);
        throw error;
    }
};

export const getColdefByQueryName = async (app, queryName) => {
    try {
        const response = await callAPI.get(`/admin/coldefbyname/${app}/${queryName}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching coldef by query name:', error);
        throw error;
    }
};

export const updateColdef = async (id, data) => {
    try {
        const response = await callAPI.put(`/admin/coldef/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating coldef:', error);
        throw error;
    }
};

///////////////////////////////////////////////
// Gestion des Apps
///////////////////////////////////////////////

export const getApps = async (page = 1, limit = 10, sort = 'ASC', order = 'id') => {
    try {
        const response = await callAPI.get("/admin/app", {
            params: { page, limit, sort, order }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching apps:', error);
        throw error;
    }
};

export const getApp = async (id) => {
    try {
        const response = await callAPI.get(`/admin/app/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching app:', error);
        throw error;
    }
};

export const getLayout = async () => {
    try {
        const response = await callAPI.get('/admin/layout');
        return response.data;
    } catch (error) {
        console.error('Error fetching layout:', error);
        throw error;
    }
};

// Pages
export const getPages = async (appId) => {
    try {
        const response = await callAPI.get(`/admin/pages`, { params: { app_id: appId } });
        return response.data;
    } catch (error) {
        console.error('Error fetching pages:', error);
        throw error;
    }
};

export const getPage = async (id) => {
    try {
        const response = await callAPI.get(`/admin/pages/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching page:', error);
        throw error;
    }
};

export const createPage = async (page) => {
    try {
        const response = await callAPI.post('/admin/pages', page);
        return response.data;
    } catch (error) {
        console.error('Error creating page:', error);
        throw error;
    }
};

export const updatePage = async (id, page) => {
    try {
        const response = await callAPI.put(`/admin/pages/${id}`, page);
        return response.data;
    } catch (error) {
        console.error('Error updating page:', error);
        throw error;
    }
};

export const switchPage = async (srcId, destId) => {
    try {
        const response = await callAPI.get(`/admin/pages/switch/${srcId}/with/${destId}`);
        return response.data;
    } catch (error) {
        console.error('Error switching page:', error);
        throw error;
    }
};

export const deletePage = async (id) => {
    try {
        const response = await callAPI.delete(`/admin/pages/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting page:', error);
        throw error;
    }
};